export class AppTextStatic {
    introform = {
        introTitle: {
            "en": "My Money Week Resource Hub",
            "cy": "Hyb Adnoddau Wythnos Fy Arian"
        },
        introText: {
            "en": "<p class='register-statement'>My Money Week is the national campaign and activity week for financial education for young people. This activity week empowers primary and secondary students with the skills, knowledge and confidence they will need to manage their money and thrive in today's world.</p><p>Sign up for a free My Money Week account to access high quality, ready to teach resources designed for teachers who are new to financial education.</p><p>Parents and home educators: Please register using your child's school name and address, and select ‘Parent or Home Educator’ for both Organisation Type and Role.</p><p>👉 Register now - it's free! </p>",
            "cy": "<p class='register-statement'>Wythnos genedlaethol o weithgareddau ar gyfer plant a phobl ifanc oed ysgol gynradd ac uwchradd yw Wythnos Fy Arian, sy'n rhoi cyfle gwych iddynt ennill y sgiliau, y wybodaeth a'r hyder mewn materion ariannol i ffynnu mewn cymdeithas. Mae'r adnoddau'n hyblyg i'w defnyddio mewn amrywiaeth o leoliadau, ac mae'r adnoddau diweddaraf yn cynnwys Canllaw i Athrawon a Chanllaw Dysgu Gartref i gynorthwyo athrawon, rhieni, a gweithwyr ieuenctid i ddefnyddio adnoddau Wythnos Fy Arian yn yr ysgol a gartref.</p><p>Gall athrawon, rhieni ac unrhyw un sy'n gweithio gyda phlant a phobl ifanc gofrestru ar gyfer cyfrif Wythnos Fy Arian am ddim isod. Bydd hyn yn caniatáu i chi gael mynediad at holl adnoddau Wythnos Fy Arian yn ôl i 2014 ac yn sicrhau y byddwch yn cael gwybod pan fydd adnoddau newydd ar gael. Gofynnir i chi gofrestru grŵp oedran y bobl ifanc rydych yn gweithio gyda nhw, ond gallwch gael at adnoddau cynradd ac uwchradd.</p><p>Nodyn i rieni: I gofrestru ar gyfer Hyb Adnoddau Wythnos Fy Arian fel rhiant, defnyddiwch enw a chyfeiriad ysgol eich plentyn yn y meysydd Enw'r Sefydliad a Chyfeiriad y Sefydliad ar y ffurflen gofrestru, a dewiswch Riant neu Addysgwr Gartref o dan y Math o Sefydliad a Rôl.</p><p>Cofrestrwch am ddim isod.</p>"
        },
        createPassword: {
            "en": "Create Password",
            "cy": "Creu Cyfrinair"
        },
        createPassword: {
            "en": "Create Password",
            "cy": "Creu Cyfrinair"
        },
        repeatPassword: {
            "en": "Repeat Password",
            "cy": "Ailadrodd Cyfrinair"
        },
        matchPassword: {
            "en": "Please make sure your passwords match",
            "cy": "Gwnewch yn siŵr bod eich cyfrineiriau'n cyfateb"
        },
        regTitle: {
            "en": "Registration Information",
            "cy": "Gwybodaeth Gofrestru"
        },
        regFullName: {
            "en": "Your Full Name",
            "cy": "Eich Enw Llawn"
        },
        regHaveAccount: {
            "en": "Already have an account?",
            "cy": "Oes gennych chi gyfrif yn barod?"
        },
        moreInfo: {
            "en": "For more information about how we store and use your data please see the website",
            "cy": "I gael rhagor o wybodaeth am sut rydym yn storio a defnyddio'ch data, darllenwch Bolisi"
        },
        privacy: {
            "en": "Privacy Policy",
            "cy": "Preifatrwydd y wefan"
        },
        login: {
            "en": "Login",
            "cy": "Mewngofnodi"
        },
        loginSuccess: {
            "en": "Login successful",
            "cy": "Wedi mewngofnodi’n llwyddiannus"
        },
        close: {
            "en": "CLOSE",
            "cy": "CAU"
        },
        change: {
            "en": "Change",
            "cy": "Newid"
        },
        reset: {
            "en": "Reset",
            "cy": "Ailosod"
        },
        password: {
            "en": "Password",
            "cy": "Cyfrinair"
        },
        forgotPassword: {
            "en": "Forgotten Password?",
            "cy": "Wedi anghofio'r cyfrinair?"
        },
        requestReset: {
            "en": "Request Password Reset",
            "cy": "Gofyn am Ailosod Cyfrinair"
        },
        passwordSuccess: {
            "en": "Your password has been updated",
            "cy": "Mae eich cyfrinair wedi cael ei ddiweddaru"
        },
        numberYoung: {
            "en": "Number of Young People",
            "cy": "Nifer y Bobl Ifanc"
        },
        numberYoungDetail: {
            "en": "Please confirm how many young people you expect to deliver My Money Week activities to this year.",
            "cy": "Cadarnhewch faint o bobl ifanc rydych yn disgwyl cyflwyno gweithgareddau Wythnos Fy Arian iddynt eleni."
        },
        findAddress: {
            "en": "Find Organisation Address",
            "cy": "Dod o Hyd i Gyfeiriad y Sefydliad"
        },
        submit: {
            "en": "Submit",
            "cy": "Cyflwyno"
        },
        registerButton1: {
            "en": "Register",
            "cy": "Cofrestru"
        },
        regsuccess: {
            "en": "Registration successful, please provide some additional information before proceeding.",
            "cy": "Wedi cofrestru'n llwyddiannus. Rhowch ychydig o wybodaeth ychwanegol cyn symud ymlaen."
        },
        regsuccess1: {
            "en": "Registration successful, you have been automatically logged in.",
            "cy": "Wedi cofrestru'n llwyddiannus. Rydych wedi cael eich mewngofnodi'n awtomatig."
        },
        incorrectEmail: {
            "en": "Incorrect email or password.",
            "cy": "Cyfeiriad e-bost neu gyfrinair anghywir."
        },
        validationPassword: {
            "en": "Please enter your existing password to register for My Money Week.",
            "cy": "Rhowch eich cyfrinair presennol i gofrestru ar gyfer Wythnos Fy Arian."
        },
        existingReg: {
            "en": "Our records show you have already registered your details on our website. Please use the same password to register for your My Money Week account. If you have forgotten your existing password, please contact us on info@y-e.org.uk.",
            "cy": "Mae ein cofnodion yn dangos eich bod eisoes wedi cofrestru'ch manylion ar ein gwefan. Defnyddiwch yr un cyfrinair i gofrestru ar gyfer eich cyfrif Fy Wythnos Arian. Os ydych wedi anghofio'ch cyfrinair presennol, cysylltwch â ni ar info@y-e.org.uk."
        },
        passRequirement: {
            "en": "Password must include uppercase",
            "cy": "Mae'n rhaid i'r cyfrinair gynnwys priflythrennau"
        },
        passresetInstructions: {
            "en": "Password reset instructions have been sent to the email address provided.",
            "cy": "Mae cyfarwyddiadau ar gyfer ailosod cyfrinair wedi cael eu hanfon i'r cyfeiriad e-bost a roddwyd."
        },
        recordUpdate: {
            "en": "Thank you, our records have been updated.",
            "cy": "Diolch, mae ein cofnodion wedi cael eu diweddaru."
        },
        invalidPostcode: {
            "en": "value is not a valid postcode.",
            "cy": "Nid yw value yn god post dilys."
        },
        findCentre: {
            "en": "Can't find school?",
            "cy": "Methu dod o hyd i ysgol?"
        }
    };
    account = {
        myaccount: {
            "en": "My Account",
            "cy": "Fy Nghyfrif"
        },
        accountTitle: {
            "en": "Account Information",
            "cy": "Gwybodaeth am y Cyfrif"
        },
        accountType: {
            "en": "Organisation/Person Type",
            "cy": "Sefydliad/Math o Berson"
        },
        accountTypeOption1:{
            "en": "School / College / University (includes Pupil Referral Centres (PRUs) and Children’s Centres)",
            "cy": "Ysgol / Coleg / Prifysgol (gan gynnwys Canolfannau Cyfeirio Disgyblion (UCD) a Chanolfannau Plant)"
        },
        accountTypeOption2:{
            "en": "Parent / Carer / Guardian / Home Educator / Tutor",
            "cy": "Rhiant / Gofalwr / Gwarcheidwad / Addysgwr Cartref / Tiwtor"
        },
        accountTypeOption3:{
            "en": "Other Organisation",
            "cy": "Sefydliad Arall"
        },
        accountTypeRequired: {
            "en": "The organisation/person type field is required",
            "cy": "Mae angen y maes sefydliad/person"
        },
        yourName: {
            "en": "Your Name",
            "cy": "Eich Enw Chi"
        },
        firstName: {
            "en": "First Name",
            "cy": "Enw cyntaf"
        },
        lastName: {
            "en": "Last Name",
            "cy": "Enw olaf"
        },
        firstNameRequired: {
            "en": "The first name field is required",
            "cy": "Mae angen y maes enw cyntaf"
        },
        lastNameRequired: {
            "en": "The last name field is required",
            "cy": "Mae angen y maes enw olaf"
        },
        orgName: {
            "en": "Organisation Name",
            "cy": "Enw'r Sefydliad"
        },
        orgNameDetail: {
            "en": "If you are a parent, please enter the name of your child's school.",
            "cy": "Os ydych yn rhiant, rhowch enw ysgol eich plentyn."
        },
        orgType: {
            "en": "Organisation Type",
            "cy": "Math o Sefydliad"
        },
        orgTypeDetail: {
            "en": "If you are a parent, please select Parent or Home Educator.",
            "cy": "Os ydych yn rhiant, dewiswch Riant neu Addysgwr Gartref."
        },
        orgTypeOption1: {
            "en": "Charity",
            "cy": "Elusen"
        },
        orgTypeOption2: {
            "en": "Guides/Scouts/Rainbows/Cubs etc",
            "cy": "Geidiaid/Sgowtiaid/Enfysau/Cubiaid ac ati"
        },
        orgTypeOption3: {
            "en": "Youth Organisation",
            "cy": "Sefydliad Ieuenctid"
        },
        orgTypeOption4: {
            "en": "Credit Union",
            "cy": "Undeb Credyd"
        },
        orgTypeOption5: {
            "en": "Local Authority",
            "cy": "Awdurdod Lleol"
        },
        orgTypeOption6: {
            "en": "Bank/Building Society",
            "cy": "Banc/Cymdeithas Adeiladu"
        },
        orgTypeOption7: {
            "en": "BBC Children in Need",
            "cy": "BBC Plant Mewn Angen"
        },
        orgTypeOption8: {
            "en": "Teacher Training University/placement",
            "cy": "Hyfforddiant Athrawon Prifysgol/lleoliad"
        },
        orgTypeOption9: {
            "en": "Hospital School",
            "cy": "Ysgol Ysbyty"
        },
        orgTypeOption10: {
            "en": "Young Enterprise staff/contractors",
            "cy": "Staff/contractwyr Menter yr Ifanc"
        },
        orgTypeOption11: {
            "en": "Other",
            "cy": "Arall"
        },
        ageOption1: {
            "en": "Pre-Reception / age 0 to 4",
            "cy": "Cyn Derbyn / 0 i 4 oed"
        },
        ageOption2: {
            "en": "Reception / age 4 to 5",
            "cy": "Derbyn / 4 i 5 oed"
        },
        ageOption3: {
            "en": "Y1 / P1 / age 5 to 6",
            "cy": "Bl 1 / P1 / 5 i 6 oed"
        },
        ageOption4: {
            "en": "Y2 / P2 / age 6 to 7",
            "cy": "Bl2 / P2 / 6 i 7 oed"
        },
        ageOption5: {
            "en": "Y3 / P3 / age 7 to 8",
            "cy": "Bl3 / P3 / 7 i 8 oed"
        },
        ageOption6: {
            "en": "Y4 / P4 / age 8 to 9",
            "cy": "Bl4 / P4 / 8 i 9 oed"
        },
        ageOption7: {
            "en": "Y5 / P5 / age 9 to 10",
            "cy": "Bl5 / P5 / 9 i 10 oed"
        },
        ageOption8: {
            "en": "Y6 / P6 / age 10 to 11",
            "cy": "Bl6/P6/10 i 11 oed"
        },
        ageOption9: {
            "en": "Y7 / P7 / age 11 to 12",
            "cy": "Bl7/P7/11 i 12 oed"
        },
        ageOption10: {
            "en": "Y8 / S1 / age 12 to 13",
            "cy": "Bl8/S1/12 i 13 oed"
        },
        ageOption11: {
            "en": "Y9 / S2 / age 13 to 14",
            "cy": "Bl9/S2/13 i 14 oed"
        },
        ageOption12: {
            "en": "Y10 / S3 / age 14 to 15",
            "cy": "Bl 10 / S3 / 14 i 15 oed"
        },
        ageOption13: {
            "en": "Y11 / S4 / age 15 to 16",
            "cy": "Bl 11 / S4 / 15 i 16 oed"
        },
        ageOption14: {
            "en": "Y12 / S5 / age 16 to 17",
            "cy": "Bl 12 / S5 / 16 i 17 oed"
        },
        ageOption15: {
            "en": "Y13 / S6 / age 17 to 18",
            "cy": "Bl 13 / S6 / 17 i 18 oed"
        },
        ageOption16: {
            "en": "Age 18 and over",
            "cy": "18 oed a throsodd"
        },
        role: {
            "en": "Role",
            "cy": "Rôl"
        },
        whereDidYouHear: {
            "en": "Where did you hear about this?",
            "cy": "Ble clywsoch chi am hyn?"
        },
        roleOption1: {
            "en": "Early Years Practitioner",
            "cy": "Ymarferydd y Blynyddoedd Cynnar"
        },
        roleOption2: {
            "en": "Teacher (Primary)",
            "cy": "Athro/Athrawes (Cynradd)"
        },
        roleOption3: {
            "en": "Teacher (Secondary)",
            "cy": "Athro/Athrawes (Uwchradd)"
        },
        roleOption4: {
            "en": "Teacher (Other)",
            "cy": "Athro/Athrawes (Arall)"
        },
        roleOption5: {
            "en": "Teaching Assistant",
            "cy": "Cynorthwy-ydd Addysgu"
        },
        roleOption6: {
            "en": "Head Teacher",
            "cy": "Pennaeth"
        },
        roleOption7: {
            "en": "Deputy/Assistant Head",
            "cy": "Dirprwy Bennaeth/Pennaeth Cynorthwyol"
        },
        roleOption8: {
            "en": "Curriculum/Subject Leader",
            "cy": "Arweinydd Cwricwlwm/Pwnc"
        },
        roleOption9: {
            "en": "Phase/Year Group Leader",
            "cy": "Arweinydd Cyfnod/Grŵp Blwyddyn"
        },
        roleOption10: {
            "en": "Youth Worker",
            "cy": "Gweithiwr Ieuenctid"
        },
        roleOption11: {
            "en": "Tutor",
            "cy": "Tiwtor"
        },
        roleOption12: {
            "en": "Youth Worker",
            "cy": "Gweithiwr Ieuenctid"
        },
        roleOption13: {
            "en": "Other",
            "cy": "Arall"
        },
        whereDidYouHearOption1: {
            "en": "Email campaign",
            "cy": "TOYmgyrch e-bostDO"
        },
        whereDidYouHearOption2: {
            "en": "Advert",
            "cy": "Hysbyseb"
        },
        whereDidYouHearOption3: {
            "en": "Event/Exhibition",
            "cy": "Digwyddiad/Arddangosfa"
        },
        whereDidYouHearOption4: {
            "en": "Facebook",
            "cy": "Facebook"
        },
        whereDidYouHearOption5: {
            "en": "LinkedIn",
            "cy": "LinkedIn"
        },
        whereDidYouHearOption6: {
            "en": "Twitter",
            "cy": "Trydar"
        },
        whereDidYouHearOption7: {
            "en": "Other social media",
            "cy": "Cyfryngau cymdeithasol eraill"
        },
        whereDidYouHearOption8: {
            "en": "Taken part before",
            "cy": "Wedi cymryd rhan o'r blaen"
        },
        whereDidYouHearOption9: {
            "en": "TV or radio programme",
            "cy": "Rhaglen deledu neu radio"
        },
        whereDidYouHearOption10: {
            "en": "Word of mouth",
            "cy": "Ar lafar gwlad"
        },
        whereDidYouHearOption11: {
            "en": "Young Enterprise staff",
            "cy": "Staff Menter yr Ifanc"
        },
        ageGroup: {
            "en": "Age Group(s) of Young People (select all that apply)",
            "cy": "Grŵp Oedran y Bobl Ifanc (dewiswch bob un sy'n berthnasol)"
        },
        ageGroupDetail: {
            "en": "Please select the age group of the young people you intend to use the MMW resources with (you will still have access to all MMW resources for all age groups).",
            "cy": "Dewiswch grŵp oedran y bobl ifanc rydych yn bwriadu defnyddio adnoddau Wythnos Fy Arian gyda nhw (gallwch gael at holl adnoddau Wythnos Fy Arian ar gyfer pob grŵp oedran o hyd)."
        },
        ageGroupBoth: {
            "en": "Both age groups",
            "cy": "Y ddau grŵp oedran"
        },
        numberYoung: {
            "en": "Number of Young People",
            "cy": "Nifer y Bobl Ifanc"
        },
        numberYoungDetail: {
            "en": "Please enter the number of young people you expect to deliver My Money Week activities to this year.",
            "cy": "Rhowch nifer y bobl ifanc rydych yn disgwyl cyflwyno gweithgareddau Wythnos Fy Arian iddynt eleni."
        },
        numberEducators: {
            "en": "Number of Educators",
            "cy": "Nifer yr Addysgwyr"
        },
        numberEducatorsDetail: {
            "en": "Please enter the number of educators you expect to share My Money Week activities with this year.",
            "cy": "Nodwch nifer yr addysgwyr yr ydych yn disgwyl rhannu gweithgareddau Fy Wythnos Arian â nhw eleni."
        },
        orgAddress: {
            "en": "Organisation Address",
            "cy": "Cyfeiriad y Sefydliad"
        },
        findAddress: {
            "en": "Can't find address?",
            "cy": "Methu dod o hyd i'r cyfeiriad?"
        },
        addressPlaceholder: {
            "en": "Start type the address to search (e.g. OX4 or 10 High Street)",
            "cy": "Dechreuwch deipio'r cyfeiriad i chwilio (e.e. OX4 neu 10 High Street)"
        },
        centrePlaceholder: {
            "en": "Start type the name to search (e.g. City of London )",
            "cy": "Dechreuwch deipio'r enw i'w chwilio (e.e. Dinas Llundain )"
        },
        fullNameRequired: {
            "en": "The name field is required",
            "cy": "Mae'r maes enw yn ofynnol"
        },
        orgNameRequired: {
            "en": "The organisation field is required",
            "cy": "Mae'r maes sefydliad yn ofynnol"
        },
        orgTypeRequired: {
            "en": "The organisation type field is required",
            "cy": "Mae'r maes math o sefydliad yn ofynnol"
        },
        orgRoleRequired: {
            "en": "The role field is required",
            "cy": "Mae'r maes rôl yn ofynnol"
        },
        whereDidYouHearRequired: {
            "en": "The where did you hear about this field is required",
            "cy": "Mae angen ble glywsoch chi am y maes hwn"
        },
        ageGroupRequired: {
            "en": "The age group field is required",
            "cy": "Mae'r maes grŵp oedran yn ofynnol"
        },
        numberYoungRequired: {
            "en": "The number of young people field is required",
            "cy": "Mae'r maes nifer y bobl ifanc yn ofynnol"
        },
        numberEducatorsRequired: {
            "en": "The number of educators field is required",
            "cy": "Mae angen maes nifer yr addysgwyr"
        },
        orgAddressRequired: {
            "en": "Organisation address field is required.",
            "cy": "Mae'r maes 'cyfeiriad y sefydliad' yn ofynnol."
        },
        centreAddressRequired: {
            "en": "School name field is required.",
            "cy": "Mae angen maes enw ysgol."
        },
        centreNameRequired: {
            "en": "School name field is required.",
            "cy": "Mae angen maes enw ysgol."
        },
        centrePostcodeRequired: {
            "en": "School postcode field is required.",
            "cy": "Mae angen maes cod post yr ysgol."
        },
        emailRequired: {
            "en": "The email field is required",
            "cy": "Mae'r maes cyfeiriad e-bost yn ofynnol"
        },
        passwordRequired: {
            "en": "The password field is required",
            "cy": "Mae'r maes cyfrinair yn ofynnol"
        },
        passwordRequiredUpper: {
            "en": "Your new password must include uppercase",
            "cy": "Mae'n rhaid i'ch cyfrinair newydd gynnwys priflythyren"
        },
        addressLine1Required: {
            "en": "The address Line 1 is required",
            "cy": "Mae Llinell 1 y cyfeiriad yn ofynnol"
        },
        addressLine2Required: {
            "en": "The address Line 2 is required",
            "cy": "Mae Llinell 2 y cyfeiriad yn ofynnol"
        },
        cityRequired: {
            "en": "The city field is required",
            "cy": "Dinas cyfrinair yn ofynnol"
        },
        postcodeRequired: {
            "en": "The postcode is required",
            "cy": "Mae'r cod post yn ofynnol"
        },
        addressLine1: {
            "en": "Address Line 1",
            "cy": "Cyfeiriad (Llinell 1)"
        },
        addressLine2: {
            "en": "Address Line 2",
            "cy": "Cyfeiriad (Llinell 2)"
        },
        city: {
            "en": "City",
            "cy": "Dinas"
        },
        autoFindAddress: {
            "en": "Automatically find address",
            "cy": "Dod o hyd i'r cyfeiriad yn awtomatig"
        },
        autoFindCentre: {
            "en": "Automatically find school",
            "cy": "Dod o hyd i'r ysgol yn awtomatig"
        },
        postCode: {
            "en": "Postcode",
            "cy": "Cod Post"
        },
        personalInfo: {
            "en": "Personal Information",
            "cy": "Gwybodaeth Bersonol"
        },
        emailAddress: {
            "en": "Email Address",
            "cy": "Cyfeiriad E-bost"
        },
        changePassword: {
            "en": "Change Password",
            "cy": "Newid Cyfrinair"
        },
        resetPassword: {
            "en": "Reset Password",
            "cy": "Ailosod Cyfrinair"
        },
        newPassword: {
            "en": "New Password",
            "cy": "Cyfrinair Newydd"
        },
        financialEducation: {
            "en": "If you would like to receive the termly Financial Education e-newsletter please tick here",
            "cy": "Os hoffech gael yr e-gylchlythyr Addysg Ariannol bob tymor, ticiwch yma"
        },
        info: {
            "en": "If you would like to receive information from Young Enterprise on new initiatives and support available to you please tick here",
            "cy": "Os hoffech gael gwybodaeth gan Young Enterprise am fentrau newydd a chymorth sydd ar gael i chi, ticiwch yma"
        },
        contactPreferences: {
            "en": "We will use the details you register here to contact you about My Money Week. If you would like to receive information from Young Enterprise on new initiatives and support available to you join our mailing list.",
            "cy": "Byddwn yn defnyddio'r manylion a gofrestrwch yma i gysylltu â chi ynglŷn ag Wythnos Fy Arian. Os hoffech dderbyn gwybodaeth gan Young Enterprise am fentrau newydd a chymorth sydd ar gael i chi, ymunwch â'n rhestr bostio."
        },
        updateInfo: {
            "en": "Update Info",
            "cy": "Diweddaru Gwybodaeth"
        },
        logout: {
            "en": "Logout",
            "cy": "Allgofnodi"
        },
        accountUpdated: {
            "en": "Your account information has been updated.",
            "cy": "Mae gwybodaeth eich cyfrif wedi cael ei diweddaru."
        },
        error: {
            "en": "Apologies, something appears to have gone wrong. Please try again.",
            "cy": "Yn anffodus, mae'n ymddangos bod rhywbeth wedi mynd o'i le. Rhowch ail gynnig arni."
        },
        accountLoggedOut: {
            "en": "You have been logged out.",
            "cy": "Rydych wedi cael eich allgofnodi."
        },
        passwordInstructions: {
            "en": "Password reset instructions have been sent to your email address.",
            "cy": "Mae cyfarwyddiadau ar gyfer ailosod cyfrinair wedi cael eu hanfon i'ch cyfeiriad e-bost."
        },
        passwordRequirement: {
            "en": "Password must be at least 6 characters.",
            "cy": "Mae'n rhaid i'r cyfrinair gynnwys 6 nod o leiaf."
        },
        emailFormat: {
            "en": "The email field must be a valid email",
            "cy": "Mae'n rhaid i'r maes e-bost fod yn gyfeiriad e-bost dilys"
        },
        emailExistsReg: {
            "en": "This email already exists, please try logging in.",
            "cy": "Mae'r cyfeiriad e-bost hwn eisoes yn bodoli, ceisiwch fewngofnodi."
        },
        fieldRequired: {
            "en": "This field is required.",
            "cy": "Mae'r maes hwn yn ofynnol."
        },
        fieldRequiredRaw: {
            "en": "field is required",
            "cy": "maes gofynnol"
        },
        the: {
            "en": "The",
            "cy": "Y"
        },
        newpassword: {
            "en": "new password",
            "cy": "cyfrinair newydd"
        },
        fieldNumeric: {
            "en": "This field can only contain numeric characters.",
            "cy": "Gall y maes hwn gynnwys nodau rhifol yn unig."
        },
        findCentre: {
            "en": "School Name",
            "cy": "Enw Ysgol"
        },
        centreName: {
            "en": "School Name",
            "cy": "Enw Ysgol"
        },
        centrePostcode: {
            "en": "School Postcode",
            "cy": "Côd Post yr Ysgol"
        }
    };
    popup = {
        confirm: {
            "en": "CONFIRM",
            "cy": "CADARNHAU"
        },
        cancel: {
            "en": "CANCEL",
            "cy": "CANSLO"
        },
    };
    dashboard = {
        title: {
            "en": "We'd love your feedback!",
            "cy": "Hoffem gael eich adborth!"
        },
        introText: {
            "en": "At Young Enterprise, we're always interested in hearing from you - we would be grateful if you could spare a few minutes to let us know what you think of our My Money Week resources, how you've used them with young people, and any suggestions you have for future resources or My Money Week activities.",
            "cy": "Yn Young Enterprise, rydym bob amser yn awyddus i glywed gennych - byddem yn ddiolchgar pe gallech neilltuo ychydig funudau i roi eich barn i ni am ein hadnoddau Wythnos Fy Arian, sut rydych wedi'u defnyddio gyda phobl ifanc, ac unrhyw awgrymiadau sydd gennych ar gyfer adnoddau neu weithgareddau Wythnos Fy Arian yn y dyfodol."
        },
        introTextLive: {
            "en": "Welcome to our My Money Week Resource Hub. We would love to hear what you did for My Money Week this year, and what you thought of our resources. We would be grateful if you could spare a few minutes to give us some feedback!",
            "cy": "Croeso i'n Hyb Adnoddau Wythnos Fy Arian. Hoffem glywed beth wnaethoch chi ar gyfer Wythnos Fy Arian eleni, a beth oedd eich barn am ein hadnoddau. Byddem yn ddiolchgar pe gallech neilltuo ychydig funudau i roi adborth i ni!"
        },
        surveyButton:{
            "en": "Fill Out Survey",
            "cy": "Llenwi'r Arolwg",
        },
        surveySuccess:{
            "en": "Are you sure you want to close?<br/>All Survey progress will be lost!",
            "cy": "Ydych chi'n siŵr eich bod eisiau cau?<br/>Byddwch yn colli'ch holl atebion i'r Arolwg hyd yma!",
        },
        surveySuccessSubmit:{
            "en": "Thank you for completing the MMW Survey.",
            "cy": "Diolch am lenwi Arolwg Wythnos Fy Arian.",
        },
        liveTitle:{
            "en": "My Money Week Resource Hub",
            "cy": "Hyb Adnoddau Wythnos Fy Arian",
        },
        liveIntro:{
            "en": "<p>All of our My Money Week resources are available for download here. Our latest My Money Week resources, released at the beginning of the Summer Term, are below.</p>          <p>Click on the Get Started button to access the Teachers' Guide, which explains the different resources available and how these can be used by teachers, parents and anyone working with children and young people to plan My Money Week activities. We have also created Home Learning Guides, which set out how the resources can be used by parents and carers as part of home learning activities.</p><p>You can also access all resources from previous My Money Weeks back to 2014 in the Resource Archive further down the page.</p>",
            "cy": "<p>Mae ein holl adnoddau Wythnos Fy Arian ar gael i'w lawrlwytho yma. Mae adnoddau diweddaraf Wythnos Fy Arian, a ryddhawyd ar ddechrau Tymor yr Haf, ar gael isod.</p> <p>Cliciwch ar y botwm Dechrau Arni i gael at y Canllaw i Athrawon, sy'n esbonio'r gwahanol adnoddau sydd ar gael a sut gall athrawon, rhieni ac unrhyw un sy'n gweithio gyda phlant a phobl ifanc eu defnyddio i gynllunio ar gyfer gweithgareddau Wythnos Fy Arian. Rydym hefyd wedi creu Canllawiau Dysgu Gartref, sy'n amlinellu sut gall rhieni a gofalwyr ddefnyddio'r adnoddau yn rhan o weithgareddau dysgu gartref.</p><p>Gallwch hefyd gael at yr holl adnoddau o Wythnosau Fy Arian blaenorol yn ôl i 2014 yn yr Archif Adnoddau ymhellach i lawr y dudalen.</p>",
        },
        liveSwitchTitleP:{
            "en": "Primary",
            "cy": "Cynradd",
        },
        liveSwitchTitleS:{
            "en": "Secondary",
            "cy": "Uwchradd",
        },
        getStartedButton:{
            "en": "GET STARTED",
            "cy": "DECHRAU ARNI",
        },
        viewResouresButton:{
            "en": "View Resources",
            "cy": "Gweld Adnoddau",
        },
        expandToViewMore:{
            "en": "Expand to view more",
            "cy": "Ehangwch i weld mwy",
        },
        resources:{
            "en": "Resources",
            "cy": "Adnoddau",
        },
        year:{
            "en": "Year",
            "cy": "Blwyddyn",
        },
        age:{
            "en": "Ages",
            "cy": "Oedrannau",
        },
        resourceAgeGroup:{
            "en": "Resource Age Group",
            "cy": "Grŵp Oedran yr Adnodd",
        },
        resourceArchiveTitle:{
            "en": "Resource Archive",
            "cy": "Archif Adnoddau",
        },
        resourceArchiveText:{
            "en": "This archive contains all of the resources from previous My Money Weeks since 2014. You can filter your search by year or age group. If you can't find the particular resource you're looking for, just contact our Advisory Service and they will be happy to help.",
            "cy": "Mae'r archif hon yn cynnwys yr holl adnoddau o Wythnosau Fy Arian blaenorol ers 2014. Gallwch hidlo'ch chwiliad yn ôl blwyddyn neu grŵp oedran. Os na allwch ddod o hyd i'r adnodd penodol rydych yn chwilio amdano, cysylltwch â'n Gwasanaeth Cynghori a fydd yn falch o'ch helpu.",
        }
    };
    footer = {
        quickLinkReturn: {
            "en": "Return to Young Enterprise Website",
            "cy": "Dychwelyd i Wefan Young Enterprise",
        },
        quickLinkcontact: {
            "en": "Contact the Advisory Service",
            "cy": "Cysylltu â'r Gwasanaeth Cynghori",
        }
    };
}


// WEBPACK FOOTER //
// ./src/plugins/appTextStatic.js